import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Button } from "../../../../assets/styles/ButtonStyle";
import { Sub2 } from "../../../../assets/styles/Typography";
import { palette } from "../../../../assets/styles/Palette";
import { setRotationTimeInfoBoard } from "../../../../utils/indexedDB";

const MoleculeInfoContentSettingPopup = ({ customerId, onClose, onUpdate = null, contentList }) => {
  const [selectedRotationTime, setSelectedRotationTime] = useState("");

useEffect(() => {
  if (contentList && contentList.length > 0) {
    setSelectedRotationTime(String(contentList[0].lotationTime));
  }
}, [contentList]);

  const rotationTimeOptions = [
    { value: "3", label: "3초" },
    { value: "5", label: "5초" },
    { value: "10", label: "10초" },
    { value: "30", label: "30초" },
    { value: "60", label: "1분" },
    { value: "90", label: "1분 30초" },
  ];

  const handleSave = async () => {
    try {
      if (!customerId) {
        onClose();
        return;
      }
      await setRotationTimeInfoBoard({
        customer_id: customerId,
        rotation_time: selectedRotationTime,
      });
      if (onUpdate) {
        await onUpdate();
      }
      window.location.reload();
    } catch (e) {
      console.error("설정 저장 실패:", e);
    }
  };
  return (
    <>
      <Overlay onClick={onClose} />
      <PopupContainer>
        <Header>
          <Heading>콘텐츠 설정</Heading>
          <CloseButton onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6L18 18" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </CloseButton>
        </Header>

        <Body>
          <SectionTitle>
            <SectionTitleText>콘텐츠 순환 시간</SectionTitleText>
            <SectionDescription>각 콘텐츠가 표시되는 시간을 설정합니다</SectionDescription>
          </SectionTitle>
          <RadioGroup>
            {rotationTimeOptions.map((option) => (
              <RadioCard
                key={option.value}
                checked={String(selectedRotationTime) === String(option.value)}
                onClick={() => setSelectedRotationTime(option.value)}
              >
                <RadioCardContent>
                  <RadioCardTitle>{option.label}</RadioCardTitle>
                  <CustomRadio checked={String(selectedRotationTime) === String(option.value)} />
                </RadioCardContent>
                <HiddenRadioInput
                  type="radio"
                  name="rotationTime"
                  value={option.value}
                  checked={String(selectedRotationTime) === String(option.value)}
                  onChange={(e) => setSelectedRotationTime(e.target.value)}
                />
              </RadioCard>
            ))}
          </RadioGroup>
        </Body>

        <Footer>
          <Button Large Gray Fill onClick={onClose} style={{ minWidth: "90px", height: "40px" }}>
            <Sub2 color="gray700">닫기</Sub2>
          </Button>
          <Button Large Primary Fill onClick={handleSave} style={{ minWidth: "90px", height: "40px" }}>
            <Sub2 color="white">저장</Sub2>
          </Button>
        </Footer>
      </PopupContainer>
    </>
  );
};

export default MoleculeInfoContentSettingPopup;

const PopupContainer = styled.div`
  width: 720px;
  max-width: 90vw;
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 40px 40px 24px 40px;
  background: white;
  border-bottom: 1px solid ${palette.outlineGray};
`;

const Heading = styled.h2`
  font-size: 28px;
  font-weight: 700;
  color: ${palette.gray900};
  margin: 0;
  line-height: 1.2;
  text-align: left;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -4px;
  &:hover { background: ${palette.gray100}; }
`;

const Body = styled.div`
  padding: 24px 40px 40px 40px;
`;

const SectionTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: left;
  margin-bottom: 16px;
`;

const SectionTitleText = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: ${palette.gray900};
  margin: 0;
  text-align: left;
`;

const SectionDescription = styled.p`
  font-size: 15px;
  font-weight: 400;
  color: ${palette.gray600};
  margin: 0;
  line-height: 1.4;
  text-align: left;
`;

const RadioGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
`;

const RadioCard = styled.div`
  border: 2px solid ${({ checked }) => (checked ? "#226FFF" : "#E0E4EB")};
  background: ${({ checked }) => (checked ? "rgba(34, 111, 255, 0.02)" : "#fff")};
  border-radius: 12px;
  padding: 16px 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;

  &:hover {
    border-color: ${({ checked }) => (checked ? "#226FFF" : "#BCC4D0")};
    background: ${({ checked }) => (checked ? "rgba(34, 111, 255, 0.04)" : "#F7F8FA")};
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }
`;

const RadioCardContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const RadioCardTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: ${palette.gray900};
`;

const CustomRadio = styled.span`
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid ${({ checked }) => (checked ? "#226FFF" : "#C8D1E1")};
  border-radius: 50%;
  position: relative;
  background: #fff;
  transition: all 0.2s ease;
  flex-shrink: 0;
  
  &::after {
    content: "";
    display: ${({ checked }) => (checked ? "block" : "none")};
    width: 10px;
    height: 10px;
    background: #226FFF;
    border-radius: 50%;
    position: absolute;
    top: 3px;
    left: 3px;
  }
`;

const HiddenRadioInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
`;

const Footer = styled.div`
  display: flex;
  gap: 16px;
  padding: 24px 40px;
  background: white;
  justify-content: center;
`;

const Overlay = styled.div`
  position: fixed;
  top: 0; left: 0;
  width: 100vw; height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
`;


